export default "<p>add-banco works!</p>\n"